const LS_KEY = "rlsMessengerItems";

let messengerItems = [];
let messengerIsLoaded = false;

export function messengerInit() {
	if (!messengerIsLoaded) {
		try {
			const lsItemsData = localStorage.getItem(LS_KEY) || "";

			if (lsItemsData) {
				messengerItems = JSON.parse(lsItemsData);
			}
		} catch (ex) {
			/* eslint-disable no-console */
			console.error(ex);
		}

		messengerIsLoaded = true;
	}
}

export function messengerGetItems(): Array<Object> {
	return messengerItems;
}

export function messengerSetItems(newItems: Array<Object>) {
	try {
		localStorage.setItem(LS_KEY, JSON.stringify(newItems));
	} catch (ex) {
		/* eslint-disable no-console */
		console.error(ex);
	}
}

export function messengerClearItems() {
	messengerItems = [];
	messengerSetItems(messengerItems);
}
